import React, {useEffect, useState, useRef} from 'react';
import CustomTable from '../../../components/customTable/CustomTableRiks';
import {getLanguage, t} from 'react-switch-lang';
import {endOfDay, format, parseISO, startOfDay} from 'date-fns';
import Badge from 'react-bootstrap/Badge';
import {useHistory} from 'react-router-dom';
import FilterRisk from '../riskHeader/RiskFilter';
import {deleteRisk} from '../../../services/deleteRisks';
import Prompt from '../../../components/prompt/prompt';
import Toast from '../../../components/toast/Toast';
import Swal from 'sweetalert2';
import {Spin} from 'antd';
import {getRiskColor} from "../../../utils/helpers";

const FirstTable = ({activeTab, user, departments, roles}) => {
  const [query, setQuery] = useState();
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const api = useRef();
  const actionsRedirect = {
    editUrl: '/risks/edit',
    editTooltip: 'risk-cosideration.search.editRisk',
    deleteTooltip: 'risk-cosideration.search.deleteRisk',
  };

  const toEditRisk = (id) => {
    history.push({
      pathname: `/potential-risk/${id}`,
      state: {isEditing: true},
    });
  };

  const toSingleRisk = (id) => {
    history.push(`/potential-risk/${id}`);
  };

  const toSingleRiskRight = (id) => {
    window.open(`/potential-risk/${id}`, '_blank');
  };

  useEffect(() => {
    const arr = [];
    const arrQ = [];
    departments.map((item, idx) => {
      arrQ.push(item.id);
      arr.push({value: item.id, label: item.name});
    });
    api.current = `risks?riskTypeId.equals=1&sort=id,desc&riskStatusId.equals=4&departmentSourceId.in=${arrQ.join(
      ','
    )}`;
    setLoading(false);
  }, [departments]);


  const columnsFirst = [
    {key: 'id', dataIndex: 'id', title: t('risk-cosideration.id')},
    {key: 'title', dataIndex: 'title', title: t('risk-cosideration.title')},
    {
      key: 'riskStatusName',
      dataIndex:
        getLanguage() === 'mne' ? 'riskStatusName' : 'riskStatusNameEn',
      title: t('risk-cosideration.status'),
    },
    {
      key: 'riskEstimationId',
      dataIndex: 'riskEstimationId',
      title: t('risk-cosideration.estimation'),
      render: (dataIndex) => (
        <span
          style={
            dataIndex < 5
              ? {color: '#37C35C', fontWeight: 'bold'}
              : dataIndex >= 5 && dataIndex <= 10
              ? {color: '#F59A1F', fontWeight: 'bold'}
              : {color: '#F5501F', fontWeight: 'bold'}
          }
        >
          {dataIndex}
        </span>
      ),
    },
    {
      key: 'applicationDate',
      dataIndex: 'applicationDate',
      title: t('risk-cosideration.applicationDate'),
      render: (dataIndex) => {
        return <span>{format(parseISO(dataIndex), 'dd.MM.yyyy.')}</span>;
      },
    },
    {
      key: 'riskEstimationEvaluation',
      dataIndex:
        getLanguage() === 'mne'
          ? 'riskEstimationEvaluation'
          : 'riskEstimationEvaluationEn',
      title: t('risk-cosideration.evaluation'),
      render: (dataIndex) => (
        <Badge variant={getRiskColor(dataIndex)} style={{color:'white',minWidth: '90px',paddingTop:'5px'}}>
          {dataIndex}
        </Badge>
      ),
    },
    {
      key: 'departmentSourceName',
      dataIndex:
        getLanguage() === 'mne'
          ? 'departmentSourceName'
          : 'departmentSourceNameEn',
      title: t('risk-cosideration.departmentSourceName'),
    },
  ];

  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteRisk'),
        text: t('question.deleteRisk'),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        preConfirm: async () => {
          try {
            const response = await deleteRisk(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess2', {entity: t('common.risk')}),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('Pages.messages.deleteError'),
              icon: 'error',
            });
          }
        },
      });
    });
  };

  const filterSubmit = (data) => {
    const parameters = [];
    if (data.selectRisk?.value === 'id') {
      parameters.push(`id.equals=${data.searchInput}`);
    }
    if (data.selectRisk?.value === 'title') {
      parameters.push(`title.contains=${data.searchInput}`);
    }
    if (data.dateCreated) {
      const startDate = startOfDay(new Date(data?.dateCreated))
      parameters.push(
        `applicationDate.greaterThanOrEqual=${
          format(startDate, "yyyy-MM-dd'T'HH:mm:ss")}`
      );
    }
    if (data?.dateUpdated) {
      const endDate = endOfDay(new Date(data?.dateUpdated))
      parameters.push(
        `applicationDate.lessThanOrEqual=${
          format(endDate, "yyyy-MM-dd'T'HH:mm:ss")}`
      );
    }
    if (data.selectRisk?.value === 'estimation') {
      parameters.push(`riskEstimationId.equals=${data.searchInput}`);
    }
    if (data.department) {
      let arr = [];
      data.department.length > 0 &&
        data.department.map((item, idx) => {
          arr.push(item.value);
        });
      if (arr.length > 0) {
        parameters.push(`departmentSourceId.in=${arr.join(',')}`);
      } else if (parameters.length > 0) {
        setQuery(
          'risks?riskTypeId.equals=1&sort=id,desc&riskStatusId.equals=4' +
            '&' +
            parameters.join('&')
        );
      } else {
        setQuery('risks?riskTypeId.equals=1&sort=id,desc&riskStatusId.equals=4');
      }
    } else if (data.department === null) {
      setQuery('risks?riskTypeId.equals=1&sort=id,desc&riskStatusId.equals=4');
    }

    if (parameters.find((p) => p.includes('departmentSourceId.in='))) {
      setQuery(
        'risks?riskTypeId.equals=1&sort=id,desc&riskStatusId.equals=4' +
          '&' +
          parameters.join('&')
      );
    }
  };

  return (
    <>
      {loading ? (
        <Spin spinning={loading} size={'large'} className="spinner" />
      ) : (
        <>
          <FilterRisk
            setQuery={setQuery}
            submit={filterSubmit}
            activeTab={activeTab}
            user={user}
            departments={departments}
          />
          <CustomTable
            api={query === undefined ? api.current : query}
            columns={columnsFirst}
            className={'table-hover'}
            methods={{onDelete}}
            addButtonRef={{}}
            query={query}
            actionsRedirectResponsibleUser={actionsRedirect}
            onClickRow={toSingleRisk}
            onColumnEdit={toEditRisk}
            userId={user.id}
            roles={roles}
            departments={departments}
            onColumnRowRightClick={toSingleRiskRight}
          />
        </>
      )}
    </>
  );
};

export default FirstTable;
